import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import listItems from 'flarum/common/helpers/listItems';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import localStorage from 'local-storage';
import Alert from 'flarum/common/components/Alert';
import Stream from 'flarum/common/utils/Stream';
import SearchRelevantComponent from './components/searchRelevantComponent';
export default class coreSearchPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    const searchDiscussionFilter = localStorage.get("KaterSearchDiscussionFilter") || "lastest";
    this.filterSearchDiscussionSort = Stream(searchDiscussionFilter);
    this.searchKeyword = null;
    this.searchKeywordTemp = Stream(null);
    app.history.push('search');
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const titleText = app.translator.trans("core.forum.header.search_placeholder");
    app.setTitle(app.translator.trans(titleText));
    $(".item-nav button .Button-label").text(titleText);
    $(this.element).find(".searchPageInput").focus();
  }
  view() {
    const coreUserSearchHistory = localStorage.get("coreUserSearchHistory") || [];
    const _this = this;
    return m("div", {
      className: "IndexPage"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "sideNavContainer"
    }, m("nav", {
      className: "IndexPage-nav sideNav"
    }, m("ul", null, listItems(IndexPage.prototype.sidebarItems().toArray())))), m("div", {
      className: "IndexPage-results sideNavOffset"
    }, m("div", {
      className: "searchPageHeader"
    }, m("div", {
      className: "searchPageInputContainer"
    }, m("div", {
      role: "search",
      "aria-label": "Search Forum",
      class: "Search"
    }, m("div", {
      className: "Search-input"
    }, m("input", {
      oninput: e => {
        this.searchKeywordTemp(e.target.value);
      },
      className: "FormControl searchPageInput",
      type: "search",
      placeholder: app.translator.trans('ziven-community-core.forum.search-placeholder')
    }), this.searchKeywordTemp() !== null && m("button", {
      className: "Search-clear Button Button--icon Button--link",
      type: "button",
      onclick: this.clearSearch.bind(this)
    }, m(Icon, {
      name: "fas fa-times-circle"
    })), Button.component({
      className: 'SearchButton Button Button--primary',
      onclick(e) {
        _this.searchInput(e);
      }
    }, app.translator.trans("core.forum.header.search_placeholder")))))), m("div", {
      className: "searchPageRecentContainer"
    }, this.searchKeyword === null && m("div", null, m("div", {
      className: "searchPageRecentTitle"
    }, app.translator.trans("ziven-community-core.forum.recent-search-text"), m("i", {
      className: "fas fa-trash-alt clearSearch",
      onclick: e => this.clearSearchHistory(e)
    })), m("div", {
      className: "searchPageRecentItems"
    }, coreUserSearchHistory.length === 0 && m("div", {
      className: "recentSearchEmpty"
    }, app.translator.trans("ziven-community-core.lib.list-empty")), coreUserSearchHistory.map(keyword => {
      return m("div", {
        className: "recentSearchItem",
        onclick: e => this.searchInput(e, keyword)
      }, keyword);
    }))), this.searchKeyword !== null && m(SearchRelevantComponent, {
      keyword: this.searchKeyword,
      sort: this.filterSearchDiscussionSort()
    })))));
  }
  searchInput(e, keywordHistory) {
    e.preventDefault();
    e.stopPropagation();
    this.searchKeyword = null;
    m.redraw();
    if (keywordHistory) {
      $(".searchPageInput").val(keywordHistory);
      this.searchKeywordTemp(keywordHistory);
    }
    const keyword = keywordHistory ? keywordHistory : $(".searchPageInput").val().trim();
    this.searchKeyword = this.searchKeywordTemp();
    if (keyword.length > 2) {
      this.addSearchHistory(keyword);
    } else {
      app.alerts.show(Alert, {
        type: "error"
      }, app.translator.trans("ziven-community-core.forum.search-input-too-short"));
    }
    m.redraw();
    // $(window).trigger('ZivenRecentSearchItem', keyword);
    // this.addSearchHistory(e,keyword);
  }
  clearSearch(e) {
    $(".searchPageInput").val("");
    this.searchKeywordTemp(null);
    this.searchKeyword = null;
    m.redraw();
    // this.searchInput();
  }
  addSearchHistory(keyword) {
    let userSearchHistory = localStorage.get("coreUserSearchHistory") || [];
    let userSearchHistoryNew = [keyword];
    for (let i = 0; i < userSearchHistory.length; i++) {
      const historyKeyword = userSearchHistory[i];
      if (historyKeyword !== keyword && userSearchHistoryNew.length < 9) {
        userSearchHistoryNew.push(historyKeyword);
      }
    }
    localStorage.set("coreUserSearchHistory", userSearchHistoryNew);
    m.redraw();
  }
  clearSearchHistory(e) {
    e.preventDefault();
    e.stopPropagation();
    localStorage.remove('coreUserSearchHistory');
    m.redraw();
  }
}